(function(){
  if (window.__alvaDragScroll) return;
  window.__alvaDragScroll = true;
  var FLICK_THRESHOLD = 40;
  function isFlick(sc){
    if (typeof sc.next === 'function' && typeof sc.previous === 'function') {
      var kid = sc.firstElementChild;
      return !!(kid && kid.offsetWidth > sc.clientWidth * 0.85);
    }
    return false;
  }
  function init(sc){
    if (!sc || sc.dataset.alvaDragInit) return;
    sc.dataset.alvaDragInit = '1';
    var down = false, moved = false, startX = 0, startL = 0;
    sc.addEventListener('pointerdown', function(e){
      if (e.pointerType !== 'mouse') return;
      down = true; moved = false;
      startX = e.clientX; startL = sc.scrollLeft;
      sc.style.scrollSnapType = 'none';
      sc.style.scrollBehavior = 'auto';
      sc.style.cursor = 'grabbing';
    });
    window.addEventListener('pointermove', function(e){
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      sc.scrollLeft = startL - dx;
    });
    function end(e){
      if (!down) return;
      down = false;
      sc.style.cursor = '';
      sc.style.scrollSnapType = '';
      sc.style.scrollBehavior = '';
      var dx = (e && typeof e.clientX === 'number') ? e.clientX - startX : 0;
      if (moved && isFlick(sc)) {
        try {
          if (dx <= -FLICK_THRESHOLD) {
            sc.next();
          } else if (dx >= FLICK_THRESHOLD) {
            sc.previous();
          } else {
            sc.select(sc.selectedIndex);
          }
        } catch (err) { /* fall back to native snap */ }
      }
      setTimeout(function(){ moved = false; }, 60);
    }
    window.addEventListener('pointerup', end);
    window.addEventListener('pointercancel', end);
    sc.addEventListener('click', function(e){
      if (moved) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  }
  var selector = '[data-alva-drag-scroll], scroll-carousel, .scroll-area';
  function scan(root){
    if (root.matches && root.matches(selector)) init(root);
    root.querySelectorAll(selector).forEach(init);
  }
  scan(document);
  window.addEventListener('DOMContentLoaded', function(){ scan(document); });
  window.addEventListener('load', function(){ scan(document); });
  var sched = false;
  var pending = new Set();
  new MutationObserver(function(records){
    records.forEach(function(record){
      record.addedNodes.forEach(function(node){
        if (node.nodeType === 1) pending.add(node);
      });
    });
    if (sched || !pending.size) return;
    sched = true;
    setTimeout(function(){
      sched = false;
      pending.forEach(function(node){ if (node.isConnected) scan(node); });
      pending.clear();
    }, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

